/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { useTenantDataOptional } from "contexts/tenant";

export const useCanDeploy = () => {
  const { deploy_process: deployProcess } = useTenantDataOptional();

  if (deployProcess === undefined) {
    return false;
  }

  return [
    "edit_sync_and_sms",
    "sync_and_sms",
    "edit_and_send",
    "message",
  ].includes(deployProcess ?? "");
};
